/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { getFeatureFlag } from '../../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

// MUI
import {
    Grid,
} from '@material-ui/core';

// Component
import RecipientAvatar from './RecipientAvatar';
import AddProfileForm from './AddProfileForm';

const AddProfile = ({ parentComponent }) => {
    const methods = useFormContext();
    const isRecipientAvatarShowing = useSelector(getFeatureFlag('is-recipient-book-avatar-showing'));
    const [recipientFirstInitial, setRecipientFirstInitial] = React.useState('');
    const [recipientLastInitial, setRecipientLastInitial] = React.useState('');

    return (
        <div>
            <Grid container alignItems="center" justifyContent="center" direction="column">
                {isRecipientAvatarShowing && (
                    <Grid item xs={12}>
                        <RecipientAvatar
                            width={82}
                            height={82}
                            recipientFirstInitial={recipientFirstInitial}
                            recipientLastInitial={recipientLastInitial}
                        />
                    </Grid>
                )}
            </Grid>
            <AddProfileForm
                methods={methods}
                setRecipientFirstInitial={setRecipientFirstInitial}
                setRecipientLastInitial={setRecipientLastInitial}
                parentComponent={parentComponent}
            />
        </div>
    );
};

AddProfile.propTypes = {
    parentComponent: string.isRequired,
};

export default AddProfile;
